// نسخة الطباعة لكشف الحساب
import React, { forwardRef } from 'react';
import { PrintSheet, PrintSummary, P, fmtDate } from '../../components/Reports/PrintKit';
import { fmtMoney } from '../../components/Reports/ReportKit';

const ENTRY_TYPE_NAMES = {
  1: 'قيد يومية', 2: 'قيد افتتاحي', 3: 'مبيعات', 4: 'مرتجع مبيعات', 5: 'مشتريات', 6: 'مرتجع مشتريات',
  7: 'سند صرف', 8: 'سند قبض', 9: 'تحويل', 10: 'تسوية', 11: 'إهلاك', 12: 'رواتب', 13: 'إقفال',
};
const typeName = (v) => (/^\d+$/.test(String(v ?? '')) ? ENTRY_TYPE_NAMES[Number(v)] || v : v);
const bal = (v) => {
  const n = Number(v) || 0;
  if (Math.abs(n) < 0.005) return '0.00';
  return `${fmtMoney(Math.abs(n))} ${n > 0 ? 'م' : 'د'}`;
};
const amt = (v) => (Number(v) ? fmtMoney(v) : '');

const AccountStatementPrint = forwardRef(({ reportData, fromDate, toDate, company }, ref) => {
  if (!reportData) return null;
  const opening = Number(reportData.openingBalance) || 0;

  return (
    <PrintSheet
      ref={ref}
      title="كشف حساب تفصيلي"
      subtitle={`${reportData.accountCode ?? ''} - ${reportData.accountName ?? ''}`}
      period={`من ${fmtDate(fromDate)} إلى ${fmtDate(toDate)}`}
      company={company}
    >
      <PrintSummary items={[
        ['رصيد افتتاحي', bal(opening)],
        ['إجمالي مدين', fmtMoney(reportData.totalDebit)],
        ['إجمالي دائن', fmtMoney(reportData.totalCredit)],
        ['رصيد ختامي', bal(reportData.closingBalance)],
      ]} />

      <table style={P.table}>
        <thead>
          <tr>
            <th style={{ ...P.th, width: 60 }}>رقم القيد</th>
            <th style={{ ...P.th, width: 72 }}>التاريخ</th>
            <th style={{ ...P.th, width: 80 }}>النوع</th>
            <th style={P.th}>البيان</th>
            <th style={{ ...P.th, width: 82 }}>مدين</th>
            <th style={{ ...P.th, width: 82 }}>دائن</th>
            <th style={{ ...P.th, width: 96 }}>الرصيد</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ background: '#fff7ed' }}>
            <td style={P.td}>—</td>
            <td style={P.num}>{fmtDate(fromDate)}</td>
            <td style={P.td}>—</td>
            <td style={{ ...P.td, fontWeight: 800 }}>رصيد افتتاحي</td>
            <td style={P.num}>{opening > 0 ? fmtMoney(opening) : ''}</td>
            <td style={P.num}>{opening < 0 ? fmtMoney(-opening) : ''}</td>
            <td style={{ ...P.num, fontWeight: 800 }}>{bal(opening)}</td>
          </tr>
          {(reportData.lines || []).map((r, i) => (
            <tr key={r.id ?? i}>
              <td style={P.td}>{r.entryNumber}</td>
              <td style={P.num}>{fmtDate(r.date)}</td>
              <td style={P.td}>{typeName(r.entryType)}</td>
              <td style={P.td}>{r.description}</td>
              <td style={P.num}>{amt(r.debit)}</td>
              <td style={P.num}>{amt(r.credit)}</td>
              <td style={{ ...P.num, fontWeight: 700 }}>{bal(r.balance)}</td>
            </tr>
          ))}
          {!(reportData.lines || []).length && (
            <tr><td colSpan={7} style={{ ...P.td, textAlign: 'center', color: P.colors.muted }}>لا توجد حركات خلال الفترة</td></tr>
          )}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={4} style={{ ...P.th, ...P.total }}>الإجمالي</td>
            <td style={{ ...P.num, ...P.total }}>{fmtMoney(reportData.totalDebit)}</td>
            <td style={{ ...P.num, ...P.total }}>{fmtMoney(reportData.totalCredit)}</td>
            <td style={{ ...P.num, ...P.total }}>{bal(reportData.closingBalance)}</td>
          </tr>
        </tfoot>
      </table>
      <div style={{ fontSize: 10.5, color: P.colors.muted }}>م = مدين · د = دائن</div>
    </PrintSheet>
  );
});

AccountStatementPrint.displayName = 'AccountStatementPrint';
export default AccountStatementPrint;
